import { Component, HostListener, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { selectDarkMode } from '../store/theme/theme.selectors';
import { Store } from '@ngrx/store';
import { loadTheme } from '../store/theme/theme.actions';
import { GoogleMapsModule } from '@angular/google-maps';
@Component({
  imports: [ButtonModule, RouterOutlet, ToastModule, GoogleMapsModule],
  providers: [MessageService],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private store = inject(Store);
  darkMode$ = this.store.select(selectDarkMode);
  showScrollTop = false;
  darkMode: boolean = false;

  title = 'RoseApp';

  ngOnInit(): void {
    this.store.dispatch(loadTheme());
  }
  @HostListener('window:scroll', [])
  onWindowScroll() {
    this.showScrollTop = window.pageYOffset > 400;
  }

  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
